import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { downloadReportExport } from "@/lib/reportsApi";
import { useToast } from "@/hooks/use-toast";
import { REPORTS } from "@/constants/testIds";

/** Botón "Exportar" con opciones Excel/CSV, usado en cada tab de Reportes. */
export default function ExportButtons({ reportKey, period }) {
  const [downloading, setDownloading] = useState(false);
  const { toast } = useToast();

  const handleExport = async (format) => {
    setDownloading(true);
    try {
      await downloadReportExport(reportKey, format, period);
    } catch {
      toast({ title: "No se pudo exportar el reporte", variant: "destructive" });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2" disabled={downloading} data-testid={`${REPORTS.exportButtonPrefix}${reportKey}`}>
          {downloading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
          Exportar
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => handleExport("excel")} data-testid={`${REPORTS.exportExcelOptionPrefix}${reportKey}`}>
          Excel (.xlsx)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleExport("csv")} data-testid={`${REPORTS.exportCsvOptionPrefix}${reportKey}`}>
          CSV
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
